import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { Trans } from 'react-i18next'
import { withTranslationCustom } from 'lib/i18next'
import { graphqlCurrentUserCached } from 'lib/utils/store/currentUser'

import BosDelete from 'components/BillOfSale/BosDelete/BosDelete'
import Button from 'components/UI/Button'
import LinkToCustomerService from 'components/UI/Link/LinkToCustomerService'
import AppContext from 'components/AppContext'

import './bos-ssn-change.pcss'

const BosSsnChange = ({ t, bosId, currentUser, onClose, who }) => {
    const [deleteActive, setDeleteActive] = useState(false)
    return (
        <AppContext context="bosSsnChange">
            <div className="bos-ssn-change">
                {who === 'seller' && currentUser.me.user.lastIdentification ? (
                    <p>
                        <Trans i18nKey={`billOfSale:changeSsn.${who}.ssnLocked`}>
                            Olet tunnistautunut palveluun antamallasi henkilötunnuksella, joten et voi muokata sitä. Jos olet tunnistautunut aikaisemman kaupan yhteydessä epähuomiossa toiseksi henkilöksi, ota yhteyttä <LinkToCustomerService>Customer Service</LinkToCustomerService>.
                        </Trans>
                    </p>
                ) : (
                    !deleteActive ? (
                        <>
                            <p>
                                {t(`billOfSale:changeSsn.${who}.description`)}
                            </p>
                            <div className="bos-ssn-change__actions">
                                <Button
                                    onClick={() => setDeleteActive(true)}
                                    className="button"
                                    trackName="createNewBillOfSale"
                                >
                                    {t(`billOfSale:changeSsn.${who}.confirmation.cta`)}
                                </Button>
                                {onClose && (
                                    <Button
                                        onClick={onClose}
                                        className="button button--secondary"
                                        trackName="cancel"
                                    >
                                        {t('common:cancel')}
                                    </Button>
                                )}
                            </div>
                        </>
                    ) : (
                        <BosDelete
                            bosId={bosId}
                            onClose={() => setDeleteActive(false)}
                            createNewAfterDelete
                            message={t(`billOfSale:changeSsn.${who}.confirmation.message`)}
                            submitText={t(`billOfSale:changeSsn.${who}.confirmation.cta`)}
                        />
                    )
                )}
            </div>
        </AppContext>
    )
}

BosSsnChange.propTypes = {
    bosId: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    who: PropTypes.oneOf(['seller', 'owner']).isRequired,
}

export default flowRight(
    withTranslationCustom('billOfSale'),
    graphqlCurrentUserCached,
)(BosSsnChange)
